<div class="content">
  <div class="container-fluid pasting-page">
    <div class="row">
      <div class="col d-sm-flex align-items-center justify-content-between mb-4">
        <div>
          <h1 class="dashboard-title mb-1">Pasting</h1>
          <p class="page-subtitle mb-0">
            Run Denticon pasting using the files prepared in the local Denticon folder.
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card shadow-sm pasting-card p-4 mb-4">
          <div class="setup-header">
            <div class="setup-icon">
              <i class="fa fa-folder-open"></i>
            </div>

            <div>
              <h5 class="mb-1">Required Local Folder</h5>
              <p class="text-muted mb-0">
                Prepare the files before starting the pasting process.
              </p>
            </div>
          </div>

          <div class="folder-requirement mt-4">
            <div class="folder-tree">
              <div class="folder-root">
                <i class="fa fa-folder mr-2"></i>
                <span>Denticon</span>
              </div>

              <div class="folder-child">
                <span class="tree-line"></span>
                <i class="fa fa-file-excel-o mr-2"></i>
                <div>
                  <strong>Work Order Sheet</strong>
                  <small>.xlsx or .xls</small>
                </div>
              </div>

              <div class="folder-child">
                <span class="tree-line"></span>
                <i class="fa fa-file-text-o mr-2"></i>
                <div>
                  <strong>Breakdown Form attachment(s)</strong>
                  <small>Keep the required breakdown form files inside the same Denticon folder.</small>
                </div>
              </div>
            </div>

            <div class="folder-note">
              <i class="fa fa-info-circle"></i>
              <div>
                <strong>No file upload is required on this screen.</strong>
                <span>
                  The local pasting automation will use the files placed in the
                  <b>Denticon</b> folder.
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="card shadow-sm pasting-card p-4 mb-4">
          <div class="section-heading">
            <div>
              <h5 class="mb-1">Run Pasting</h5>
              <p class="text-muted mb-0">
                Select the office and Denticon insurance, then start the process.
              </p>
            </div>

            <span class="frontend-badge">Local Automation</span>
          </div>

          <div class="pasting-action-row mt-4">
            <!-- <div class="field-wrapper">
              <label class="mb-1 font-weight-600">Select Office</label>
              <select
                class="form-control pasting-select"
                [(ngModel)]="selectedOfficeId"
                name="selectedOfficeId"
              >
                <option [ngValue]="null">Select Office</option>
                <option *ngFor="let office of OfficeType" [ngValue]="office.id">
                  {{ office.officeName || office.name }}
                </option>
              </select>
            </div> -->

            <div class="field-wrapper">
              <label class="mb-1 font-weight-600">Select PMS</label>
              <select
                class="form-control pasting-select"
                [(ngModel)]="selectedInsurance"
                name="selectedInsurance"
              >
                <option [ngValue]="null">Select PMS</option>
                <option *ngFor="let ins of insuranceOptions" [ngValue]="ins.value">
                  {{ ins.name }}
                </option>
              </select>
            </div>

            <div class="field-wrapper report-mode-wrapper">
              <label class="mb-1 font-weight-600">Report Mode</label>
              <small class="report-mode-hint" *ngIf="selectedReportMode === 'single'">
                One breakdown workbook containing multiple sheets.
              </small>

              <small class="report-mode-hint" *ngIf="selectedReportMode === 'multiple'">
                Separate breakdown file for each account.
              </small>              
              
              <select
                class="form-control pasting-select"
                [(ngModel)]="selectedReportMode"
                name="selectedReportMode"
              >
                <option *ngFor="let mode of reportModeOptions" [ngValue]="mode.value">
                  {{ mode.name }}
                </option>
              </select>


            </div>

            <div class="run-btn-wrapper">
              <label class="mb-1 d-block invisible">Run</label>
              <button
                type="button"
                class="btn btn-primary run-pasting-btn"
                [disabled]=" !selectedInsurance || !selectedReportMode || pastingRunning"
                (click)="runPasting()"
              >
                <i
                  class="fa mr-2"
                  [ngClass]="pastingRunning ? 'fa-spinner fa-spin' : 'fa-play'"
                ></i>
                {{ pastingRunning ? 'Pasting Running...' : 'Run Pasting' }}
              </button>
            </div>
          </div>
        </div>

        <div class="card shadow-sm pasting-card p-4">
          <div class="d-flex flex-wrap justify-content-between align-items-center log-header mb-3">
            <div>
              <h5 class="mb-1">Pasting Logs</h5>
              <small class="text-muted">
                Frontend activity only. Backend log API integration will be added later.
              </small>
            </div>

            <button
              type="button"
              class="btn btn-sm btn-outline-secondary"
              (click)="clearLogs()"
              [disabled]="!pastingLogs.length"
            >
              Clear
            </button>
          </div>

          <div class="log-container" *ngIf="pastingLogs.length; else noLogs">
            <div
              class="log-item"
              *ngFor="let log of pastingLogs"
              [ngClass]="{
                'log-start': log.type === 'start',
                'log-end': log.type === 'end',
                'log-info': log.type === 'info',
                'log-error': log.type === 'error'
              }"
            >
              <div class="log-time">{{ log.time }}</div>
              <div class="log-message">{{ log.message }}</div>
            </div>
          </div>

          <ng-template #noLogs>
            <div class="empty-log-state text-center">
              <div class="empty-log-icon mb-2">
                <i class="fa fa-terminal"></i>
              </div>
              <div class="mb-1">No pasting logs yet</div>
              <small class="text-muted">
                Run pasting to see frontend activity here.
              </small>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
